import axios from "axios";
import Vue from "vue";

export const state = {
  classes: [],
  streams: [],
  subjectsx: [],
  classStreams: [],
  classSubjects: [],
  filteredPromotions: [],
  filterdTermPromotions: [],
  promotedStudents: [],
  nextClassStudents: [],
  nextTermStudents: [],
  nurSubjects: [],
  courses: [],
  save_status: false,
  promotion_status: false,
  customClasses: [],
  courselevels: [],
};
export const getters = {
  AllClasses: (state) => state.classes.data,
  AllStreams: (state) => state.streams.data,
  AllSubjects: (state) => state.subjectsx.data,
  SaveStatus: (state) => state.save_status,
  AllClassStreams: (state) => state.classStreams.data,
  GetClassSubjects: (state) => state.classSubjects.data,
  getFilteredPromotions: (state) => state.filteredPromotions,
  getFilterdTermPromotions: (state) => state.filterdTermPromotions,
  getPromotedStudents: (state) => state.promotedStudents,
  promotionStatus: (state) => state.promotion_status,
  getNextClassStudents: (state) => state.nextClassStudents,
  getNextTermStudents: (state) => state.nextTermStudents,
  NurSubjects: (state) => state.nurSubjects.data,
  AllCourses: (state) => state.courses.data,
  CustomClasses: (state) => state.customClasses.data,
  CourseLevels: (state) => state.courselevels.data,
};

export const mutations = {
  SET_CLASSES(state, newValue) {
    state.classes = newValue;
  },
  SET_STREAMS(state, newValue) {
    state.streams = newValue;
  },
  SET_CLASSSTREAMS(state, newValue) {
    state.classStreams = newValue;
  },
  SET_SUBJECTS(state, newValue) {
    state.subjectsx = newValue;
  },
  SET_CLASSSUBJECTS(state, newValue) {
    state.classSubjects = newValue;
  },
  SET_SAVE_STATUS(state, newValue) {
    state.save_status = newValue;
  },
  SET_PROMOTION_STATUS(state, newValue) {
    state.promotion_status = newValue;
  },
  SET_FILTERED_PROMO_STD(state, newValue) {
    state.filteredPromotions = newValue;
  },
  SET_FILTERED_TERM_PROMO_STD(state, newValue) {
    state.filterdTermPromotions = newValue;
  },
  SET_PROMOTED_STUDENTS(state, newValue) {
    state.promotedStudents = newValue;
  },
  SET_NEXT_STUDENTS(state, newValue) {
    state.nextClassStudents = newValue;
  },
  SET_NEXT_TERM_STUDENTS(state, newValue) {
    state.nextTermStudents = newValue;
  },
  SET_ALL_COURSES(state, newValue) {
    state.courses = newValue;
  },
  SET_NURSUBJECT(state, newValue) {
    state.nurSubjects = newValue;
  },
  SET_COURSE_LEVELS(state, newValue) {
    state.customClasses = newValue;
  },
  SET_ALL_COURSE_LEVELS(state, newValue) {
    state.courselevels = newValue;
  },

  pushNotification(state, payload) {
    Vue.notify({
      type: payload.type,
      group: "foo",
      title: payload.title,
      text: payload.message,
      position: "bottom right",
      duration: 10000,
      speed: 500,
    });
  },
};

export const actions = {
  addClass({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post(`classes`, payload)
      .then(() => {
        dispatch("fetchClasses");
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Level Was Saved Successfully",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },
  // Edit Staff Position
  editClass({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .put(`classes/${payload.id}`, payload)
      .then(() => {
        dispatch("fetchClasses");
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Class Was Updated Successfully",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },
  // Delete Staff Position
  deleteClass({ commit, dispatch }, payload) {
    // console.log(payload);
    commit("SET_SAVE_STATUS", true);
    axios
      .delete(`classes/${payload.id}`)
      .then(() => {
        dispatch("fetchClasses");
        const message = {
          type: "secondary",
          title: "<b>Success Notifications</b>",
          message: "Level Was Deleted Successfully",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },

  addStream({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("streams", payload)
      .then(() => {
        dispatch("fetchStreams");
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Stream Was Saved Successfully",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },

  // Edit streams
  editStream({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .put(`streams/${payload.id}`, payload)
      .then(() => {
        dispatch("fetchStreams");
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Stream Was Updated Successfully",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },
  // Delete streams
  deleteStream({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .delete(`streams/${payload.id}`)
      .then(() => {
        dispatch("fetchStreams");
        const message = {
          type: "default",
          title: "<b>Success Notifications</b>",
          message: "Stream Was Deleted Successfully",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },

  addSubject({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("subjects", payload)
      .then((response) => {
        dispatch("fetchSubjects");
        let message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: response.data.msg,
        };
        if (!response.data.msg.includes("Successfully")) {
          message = {
            type: "error",
            title: "<b>Error Notifications</b>",
            message: response.data.msg + " <br/> <b>Please Add a New Name</b>",
          };
        }
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },

  // Edit Subject
  editSubject({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .put(`subjects/${payload.id}`, payload)
      .then(() => {
        dispatch("fetchSubjects");
        commit("SET_SAVE_STATUS", false);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },
  // Delete Subject
  deleteSubject({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .delete(`subjects/${payload.id}`)
      .then(() => {
        dispatch("fetchSubjects");
        commit("SET_SAVE_STATUS", false);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },

  //promotion actions
  promoteStudents({ commit, dispatch }, payload) {
    commit("SET_PROMOTION_STATUS", true);
    axios
      .post("students/promote", payload)
      .then((response) => {
        dispatch("fetchNextClassStudents", payload.promotionDetails);
        if (response.data.msg.includes("Already Promoted")) {
          const message = {
            type: "default",
            title: "<b>Success Notifications</b>",
            message: "Students Already Promoted",
          };
          commit("pushNotification", message);
        } else {
          const message = {
            type: "success",
            title: "<b>Success Notifications</b>",
            message: "Students Promoted Successfully",
          };
          commit("pushNotification", message);
        }
        commit("SET_FILTERED_PROMO_STD", []);
        commit("SET_PROMOTION_STATUS", false);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        commit("SET_PROMOTION_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },

  //termly promotion actions
  termlyPromoteStudents({ commit, dispatch }, payload) {
    commit("SET_PROMOTION_STATUS", true);
    axios
      .post("students/termly_promote", payload)
      .then((response) => {
        dispatch("fetchNextTermStudents", payload.promotionDetails);
        if (response.data.msg.includes("Already Promoted")) {
          const message = {
            type: "default",
            title: "<b>Success Notifications</b>",
            message: "Students Already Promoted",
          };
          commit("pushNotification", message);
        } else {
          const message = {
            type: "success",
            title: "<b>Success Notifications</b>",
            message: "Students Promoted Successfully",
          };
          commit("pushNotification", message);
        }
        commit("SET_FILTERED_PROMO_STD", []);
        commit("SET_PROMOTION_STATUS", false);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },

  promoteFailedStudents({ commit, dispatch }, payload) {
    commit("SET_PROMOTION_STATUS", true);
    // eslint-disable-next-line no-unused-vars
    axios
      .post("student/promote", payload)
      .then((response) => {
        commit("SET_PROMOTED_STUDENTS", response.data);
        dispatch("fetchNextClassStudents", payload.promotionDetails);
        dispatch("filterPromotionStudents", payload.promotionDetails);
        commit("SET_PROMOTION_STATUS", false);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },

  //next class students
  fetchNextClassStudents({ commit }, payload) {
    commit("SET_NEXT_STUDENTS", "");
    axios.post("filter/next_class", payload).then((response) => {
      commit("SET_NEXT_STUDENTS", response.data);
    });
  },

  //next term students
  fetchNextTermStudents({ commit }, payload) {
    commit("SET_NEXT_TERM_STUDENTS", "");
    axios.post("filter/next_term", payload).then((response) => {
      commit("SET_NEXT_TERM_STUDENTS", response.data);
    });
  },

  filterPromotionStudents({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("filter/promotion", payload)
      .then((response) => {
        commit("SET_FILTERED_PROMO_STD", response.data);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Fetching Students",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  filterTermlyPromotionStudents({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("filter/promotion_term", payload)
      .then((response) => {
        commit("SET_FILTERED_TERM_PROMO_STD", response.data);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Fetching Students",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  fetchClasses({ commit }) {
    commit("SET_SAVE_STATUS", true);
    axios.get(`classes`).then((pos) => {
      commit("SET_SAVE_STATUS", false);
      commit("SET_CLASSES", pos.data);
    });
  },
  fetchStreams({ commit }) {
    commit("SET_SAVE_STATUS", true);
    axios.get("streams").then((sta) => {
      commit("SET_SAVE_STATUS", false);
      commit("SET_STREAMS", sta.data);
    });
  },
  fetchClassStreams({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios.post(`streamsclass`, payload).then((sta) => {
      commit("SET_SAVE_STATUS", false);
      commit("SET_CLASSSTREAMS", sta.data);
    });
  },
  fetchSubjects({ commit }) {
    axios.get("subjects").then((sta) => {
      commit("SET_SUBJECTS", sta.data);
    });
  },
  fetchClassSubjects({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios.post(`subjectsclass`, payload).then((sta) => {
      commit("SET_CLASSSUBJECTS", sta.data);
      commit("SET_SAVE_STATUS", false);
    });
  },
  fetchNurSubjects({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios.post(`subjectsclass`, payload).then((sta) => {
      commit("SET_NURSUBJECT", sta.data);
      commit("SET_SAVE_STATUS", false);
    });
  },
  fetchCustomClasses({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios.post(`fetchcourselevels`, payload).then((sta) => {
      commit("SET_COURSE_LEVELS", sta.data);
      commit("SET_SAVE_STATUS", false);
    });
  },
  fetchCourseLevels({ commit }) {
    commit("SET_SAVE_STATUS", true);
    axios.get(`fetchallcourselevels`).then((sta) => {
      commit("SET_ALL_COURSE_LEVELS", sta.data);
      commit("SET_SAVE_STATUS", false);
    });
  },
  fetchCourses({ commit }) {
    commit("SET_SAVE_STATUS", true);
    axios.get("courses").then((sta) => {
      commit("SET_ALL_COURSES", sta.data);
      commit("SET_SAVE_STATUS", false);
    });
  },
  addCourse({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    // eslint-disable-next-line no-unused-vars
    axios
      .post("courses", payload)
      .then(() => {
        dispatch("fetchCourses");
        commit("SET_SAVE_STATUS", false);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },
  // Edit Staff Position
  editCourse({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .put(`courses/${payload.id}`, payload)
      .then(() => {
        dispatch("fetchCourses");
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Level Was Updated Successfully",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },
  // Delete Course
  deleteCourse({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .delete(`courses/${payload.id}`)
      .then(() => {
        dispatch("fetchCourses");
        const message = {
          type: "secondary",
          title: "<b>Success Notifications</b>",
          message: "Course Was Deleted Successfully",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },
};
